/* 広告（アフィリエイト）リンクの差し替え。一覧は snippets/fp-aff.liquid（window.FP_AFF）。
   - <a data-aff="key"> は key で、それ以外の外部リンクは公式サイトのドメインで探す
   - 後から描かれるリスト（料金ページ等）にも効くよう、DOM の追加を見張る
   - 差し替えたページに広告表記が無ければ、本文の先頭に1行入れる（ステマ規制） */
(function (root) {
  function hostOf(href) {
    var m = /^https?:\/\/([^\/?#:]+)/i.exec(href || '');
    return m ? m[1].toLowerCase().replace(/^www\./, '') : '';
  }

  function findHost(host, hosts) {
    for (var h = host; h; h = h.indexOf('.') > 0 ? h.slice(h.indexOf('.') + 1) : '') {
      if (hosts[h]) return hosts[h];
      if (h.indexOf('.') < 0) break;
    }
    return null;
  }

  // ctx.reviews: ページに Google の評価・口コミ（[data-google-reviews]）があるか。noReviews のブランドはそのページでは差し替えない
  function affUrl(href, key, table, ctx) {
    var host = hostOf(href);
    var hit = host ? findHost(host, table.hosts || {}) : null;
    if (hit && hit.noReviews && ctx && ctx.reviews) return null;
    // deep: true は A8 の a8ejpredirect、文字列はそのパラメータ名（もしものどこでもリンクは 'url'）
    if (hit && hit.deep) return hit.url + '&' + (typeof hit.deep === 'string' ? hit.deep : 'a8ejpredirect') + '=' + encodeURIComponent(href);
    if (key && table.keys && table.keys[key]) return table.keys[key];
    return hit ? hit.url : null;
  }

  var NOTE_RE = /アフィリエイト|プロモーションを含|広告を含み|PR表記/;
  function hasNote(text) { return NOTE_RE.test(text || ''); }

  function addNote(doc) {
    if (doc.querySelector('.fp-aff-note, .fpc-disclaimer, [data-aff-note]')) return;
    var main = doc.querySelector('main') || doc.body;
    if (hasNote(main.textContent)) return;
    var p = doc.createElement('p');
    p.className = 'fp-aff-note';
    p.textContent = 'このサイトのランクは広告や忖度一切なしで、機械的に順位を決めています。一部アフィリエイトリンクがある場合がございます。';
    p.style.cssText = 'font-size:12px;color:#777;margin:8px auto;max-width:var(--page-width,1200px);padding:0 16px';
    var h1 = main.querySelector('h1');
    if (h1 && h1.parentNode) h1.parentNode.insertBefore(p, h1.nextSibling);
    else main.insertBefore(p, main.firstChild);
  }

  function apply(scope, table, doc) {
    var ctx = { reviews: !!doc.querySelector('[data-google-reviews]') };
    var links = scope.querySelectorAll ? scope.querySelectorAll('a[href]') : [];
    var changed = 0;
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.hasAttribute('data-aff-done')) continue;
      var u = affUrl(a.getAttribute('href'), a.getAttribute('data-aff'), table, ctx);
      a.setAttribute('data-aff-done', '');
      if (!u) continue;
      a.href = u;
      a.rel = 'sponsored noopener';
      changed++;
    }
    if (changed) addNote(doc);
  }

  function start(win) {
    var table = win.FP_AFF;
    if (!table || win.__fpAffStarted) return;
    win.__fpAffStarted = true;
    var doc = win.document;
    var run = function () {
      apply(doc, table, doc);
      if (win.MutationObserver) {
        var queued = false;
        new win.MutationObserver(function () {
          if (queued) return;
          queued = true;
          win.requestAnimationFrame(function () { queued = false; apply(doc, table, doc); });
        }).observe(doc.body, { childList: true, subtree: true });
      }
    };
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', run);
    else run();
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { affUrl: affUrl, hostOf: hostOf, hasNote: hasNote };
  else start(root);
})(this);
